import React from 'react';

import { SVGComponentProps } from './svg.types';

const EducationSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M13.334 21V23.5L10.334 21.5L7.33398 23.5V21H6.83398C4.90098 21 3.33398 19.433 3.33398 17.5V5C3.33398 3.34315 4.67713 2 6.33398 2H20.334C20.8863 2 21.334 2.44772 21.334 3V20C21.334 20.5523 20.8863 21 20.334 21H13.334ZM13.334 19H19.334V16H6.83398C6.00555 16 5.33398 16.6716 5.33398 17.5C5.33398 18.3284 6.00555 19 6.83398 19H7.33398V17H13.334V19ZM19.334 14V4H6.33398V14.0354C6.49728 14.0121 6.66422 14 6.83398 14H19.334ZM7.33398 5H9.33398V7H7.33398V5ZM7.33398 8H9.33398V10H7.33398V8ZM7.33398 11H9.33398V13H7.33398V11Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default EducationSVG;
